const test = {
  displayField: 'header',
  name: 'z-test',
  description: 'Fake component',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Beach',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: { id: 'test', version: 4, updatedAt: '2023-08-03T14:39:06.444Z' }
};
export default test;